module.exports = __webpack_public_path__ + "media/images/img/topimg_sp_2-81d86d3a1b608133a7a6307dbb39cb0f.png";